import React, { useState, useEffect, useContext } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { UserAuth } from '../context/AuthContext';
import { AppContextisChecked } from '../context/AppContextisChecked';
import BasicModal from '../components/BasicModal.js';
import Avatar from '@mui/material/Avatar';
import ExitToAppIcon from '@mui/icons-material/ExitToApp';
import PowerSettingsNewIcon from '@mui/icons-material/PowerSettingsNew';

const Navbar = () => {
    const [openModal, setOpenModal] = useState(false);
    const handleOpen = () => {
        setOpenModal(true);
    }
    // State to control tooltip visibility
    const [loginTooltipVisible, setLoginTooltipVisible] = useState(false);
    const [logoutTooltipVisible, setLogoutTooltipVisible] = useState(false);
    const handleClose = () => setOpenModal(false);
    const { user, logOut, sessionTerminated } = UserAuth();
    const { auth, setAuth } = useContext(AppContextisChecked);
    const navigate = useNavigate();
    const handleSignOut = async () => {
        try {
            await logOut();
            setAuth(false)
            //navigate('/signin');
        } catch (error) {
            // console.log(error);
        }
    };
    // Redirect to signin page if session is terminated
    useEffect(() => {
        if (sessionTerminated) {
            setAuth(true)
            //navigate('/signin');
        }
    }, [sessionTerminated, navigate]);
    return (
        <div className='flex justify-between bg-gray-200 w-full p-4'>
            <div style={{
                display: 'flex',
                justifyContent: 'space-between',
                fontFamily: 'sans-serif',
                width: '100%',
                padding: '7px',
                background: 'transparent',
                color: 'white',
                // boxShadow: '0 2px 10px rgba(0,0,0,0.2)',
                alignItems: 'center',
                position: 'sticky',
                top: 0,
                zIndex: 1000
            }}>
                <BasicModal openModal={openModal} setOpenModal={setOpenModal} />
                <div style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '22px'
                }}>
                    {user?.displayName && (
                        <span style={{
                            fontFamily: 'sans-serif',
                            fontSize: '14.5px',
                            fontWeight: '545',
                            color: 'black',
                            display: 'flex',
                            alignItems: 'center',
                            gap: '6px'
                        }}>
                            {/* <Avatar>
                            <span style={{
                                // background: '#38b2ac',
                                width: '24px',
                                height: '24px',
                                borderRadius: '50%',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                fontWeight: 'bold'
                            }}>
                                {user.displayName.charAt(0)}
                            </span>
                            </Avatar> */}
                            <Avatar style={{width: '33px', height: '33px'}} src="/broken-image.jpg" />
                            {user.displayName}
                        </span>
                    )}
                    {user?.displayName ? (
                        <button
                            onClick={handleSignOut}
                            style={{
                                background: 'black',
                                color: 'white',
                                fontWeight: '500',
                                // padding: '6px 14px',
                                borderRadius: '50%',
                                border: 'none',
                                cursor: 'pointer',
                                transition: 'all 0.2s ease',
                                fontSize: '14.5px',
                                display: 'flex',
                                alignItems: 'center',
                                padding: '7px 7px',
                                // gap: '4px'
                            }}
                            onMouseOver={(e) => {
                                e.currentTarget.style.background = 'rgb(85, 76, 76)'
                                setLogoutTooltipVisible(true)
                            }}
                            onMouseOut={(e) => {
                                e.currentTarget.style.background = 'black'
                                setLogoutTooltipVisible(false)
                            }}
                        >
                            <ExitToAppIcon />
                        </button>
                    ) : (
                        <button
                            onClick={handleOpen}
                            style={{
                                background: 'black',
                                color: 'white',
                                fontWeight: '500',
                                // padding: '6px 14px',
                                borderRadius: '50%',
                                border: 'none',
                                cursor: 'pointer',
                                transition: 'all 0.2s ease',
                                fontSize: '14.5px',
                                display: 'flex',
                                alignItems: 'center',
                                padding: '7px 7px',
                                // gap: '4px'
                            }}
                            onMouseOver={(e) => {
                                e.currentTarget.style.background = 'rgb(85, 76, 76)'
                                setLoginTooltipVisible(true)
                            }}
                            onMouseOut={(e) => {
                                e.currentTarget.style.background = 'black'
                                setLoginTooltipVisible(false)
                            }}
                        >
                            <PowerSettingsNewIcon />
                        </button>
                    )}
                    {logoutTooltipVisible && (
                        <div style={{
                            position: 'absolute',
                            top: '4rem', // Position below the top bar
                            right: "-10px",
                            transform: 'translateX(-30%)',
                            backgroundColor: 'rgba(0, 0, 0, 0.75)',
                            color: 'white',
                            padding: '6px 10px',
                            borderRadius: '4px',
                            fontSize: '15px',
                            whiteSpace: 'nowrap',
                            zIndex: 100,
                            boxShadow: '0 2px 5px rgba(0, 0, 0, 0.2)'
                        }}>
                            Log Out
                        </div>
                    )}
                    {loginTooltipVisible && (
                        <div style={{
                            position: 'absolute',
                            top: '4rem', // Position below the top bar
                            right: "-10px",
                            transform: 'translateX(-30%)',
                            backgroundColor: 'rgba(0, 0, 0, 0.75)',
                            color: 'white',
                            padding: '6px 10px',
                            borderRadius: '4px',
                            fontSize: '15px',
                            whiteSpace: 'nowrap',
                            zIndex: 100,
                            boxShadow: '0 2px 5px rgba(0, 0, 0, 0.2)'
                        }}>
                            Log In
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default Navbar;